import {HoverMenu, HoverMenuItem} from "components/hover-menu"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import ChangeRoleModal from "components/school-roles/change-role-modal"
import {ContactRelationship} from "models"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import RemoveRoleModal from "components/school-roles/remove-role-modal"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import {View} from "react-native"

export default memo(shapeComponent(class ComponentsSchoolRolesUserCircleOptionsButton extends ShapeComponent {
  static defaultProps = {
    style: null
  }

  static propTypes = propTypesExact({
    schoolRole: PropTypes.instanceOf(ContactRelationship).isRequired,
    style: PropTypes.object
  })

  setup() {
    const {t} = useI18n({namespace: "js.components.school_roles.user_circle.options_button"})

    this.setInstance({t})
    this.useStates({showChangeRoleModal: false, showRemoveRoleModal: false})
  }

  render() {
    const {schoolRole, style} = this.p
    const actualStyle = useMemo(() => Object.assign({position: "relative"}, style), [style])

    return (
      <View
        dataSet={this.cache("rootViewStyle", {class: "components--school-roles--options-button", schoolRoleId: schoolRole.id()}, [schoolRole.id()])}
        style={actualStyle}
      >
        {this.s.showChangeRoleModal && schoolRole.can("edit") &&
          <ChangeRoleModal onRequestClose={this.tt.onRequestCloseChangeRoleModal} schoolRole={schoolRole} />
        }
        {this.s.showRemoveRoleModal && schoolRole.can("destroy") &&
          <RemoveRoleModal onRequestClose={this.tt.onRequestCloseRemoveRoleModal} schoolRole={schoolRole} />
        }
        <HoverMenu content={this.tt.hoverMenuContent}>
          <View style={this.iconViewStyle ||= {display: "flex", alignItems: "center", justifyContent: "center", width: 25, height: 25}}>
            <i className="fa-solid fa-ellipsis-vertical" style={this.iconStyle ||= {fontSize: 20}} />
          </View>
        </HoverMenu>
      </View>
    )
  }

  hoverMenuContent = () => {
    const {t} = this.tt
    const {schoolRole} = this.p

    return (
      <>
        {schoolRole.can("edit") &&
          <HoverMenuItem
            dataSet={this.changeRolePressableDataSet ||= {class: "change-role-pressable"}}
            label={t(".change_role")}
            onPress={this.tt.onChangeRolePressed}
          />
        }
        {schoolRole.can("destroy") &&
          <HoverMenuItem
            dataSet={this.removeAttachmentFromSchoolPressableDataSet ||= {class: "remove-attachment-from-school-pressable"}}
            label={t(".remove_attachment_from_school")}
            onPress={this.tt.onRemoveRolePressed}
          />
        }
      </>
    )
  }

  onChangeRolePressed = () => this.setState({showChangeRoleModal: true})
  onRemoveRolePressed = () => this.setState({showRemoveRoleModal: true})
  onRequestCloseChangeRoleModal = () => this.setState({showChangeRoleModal: false})
  onRequestCloseRemoveRoleModal = () => this.setState({showRemoveRoleModal: false})
}))
